const rankings = [
  {
    rank: 1,
    title: '《庆余年3》',
    tag: '热播中',
    desc: '古装权谋天花板，张若昀领衔主演',
    stat: '本周播放 28.6万',
    hot: true,
  },
  {
    rank: 2,
    title: '《流浪地球3》',
    tag: '新上线',
    desc: '国产科幻巨制第三部高清完整版',
    stat: '本周播放 24.1万',
    hot: true,
  },
  {
    rank: 3,
    title: '《乘风破浪2025》',
    tag: '综艺',
    desc: '明星竞演真人秀最新一季热播',
    stat: '本周播放 19.8万',
    hot: false,
  },
  {
    rank: 4,
    title: '《一年一度喜剧大赛》',
    tag: '综艺',
    desc: '年度最欢乐喜剧竞演节目合集',
    stat: '本周播放 16.3万',
    hot: false,
  },
  {
    rank: 5,
    title: '《重启人生》日剧',
    tag: '日剧',
    desc: '高分治愈系日剧，豆瓣9.4分神作',
    stat: '本周播放 13.7万',
    hot: false,
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            热播排行
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            本周最受欢迎的影视内容排行榜
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          {rankings.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 rounded-xl mb-3 transition-all duration-300 cursor-pointer ${
                item.hot
                  ? 'bg-primary-50 border border-primary-200'
                  : 'bg-white border border-background-200/70 hover:border-primary-200'
              }`}
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center font-bold text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-white'
                    : item.rank === 2
                    ? 'bg-accent-500 text-white'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-semibold text-foreground-950 font-serif truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-500 text-xs font-medium flex-shrink-0">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="flex items-center gap-0.5 text-xs text-primary-500 flex-shrink-0">
                      <i className="ri-fire-line"></i>
                      热
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <div className="text-xs text-foreground-400 flex-shrink-0 text-right">
                {item.stat}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}